import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import './Map.scss';

export function Map() {
  return (
    <MapContainer
      center={[48.87226962106971, 2.3844946711639374]}
      zoom={13}
      scrollWheelZoom={false}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={[48.87226962106971, 2.3844946711639374]}>
        <Popup>Lilia Massages Japonais</Popup>
      </Marker>
    </MapContainer>
  );
}
